import { get } from 'axios';

const store = {
	namespaced: true,
	state: {
		sizeDisclaimerContent: ''
	},
	mutations: {
		content(state, { prop, html }) {
			state[prop] = html;
		}
	},
	actions: {
		cms({ commit, state }, { prop, slug, isUpdate }) {
			if (!state[prop] || isUpdate) {
				get(`/service/cms/${slug}`).then(({ data }) => {
					commit('content', {
						prop,
						html: data.html
					});
				});
			}
		},
		fetchSizeDisclaimerContent({ dispatch }, isUpdate) {
			dispatch('cms', {
				prop: 'sizeDisclaimerContent',
				slug: 'widget-size-message',
				isUpdate
			});
		}
	}
};

export default store;
